import { combineReducers } from "redux";
import { authenReducer } from "./authenReducer";
import { myRecordReducer } from "./myRecordReducer";
import { listingReducer } from "./listingReducer";
import { shopReducer } from "./shopReducer";
import { shopSoldReducer } from "./shopSoldReducer";
import { taskReducer } from "./taskReducer";
import { collectionReducer } from "./collectionReducer";
import { botReducer } from "./botReducer";
import { socketReducer } from "./socketReducer";
import { miscReducer } from "./miscReducer";
import { localDataReducer } from "./localDataReducer";
import { autoP2PReducer } from "./autoP2PReducer";
import { aiConversationReducer } from "./aiConversationReducer";
import { aiMessageReducer } from "./aiMessageReducer";
import { projectReducer } from "./projectReducer";
import { commitReducer } from "./commitReducer";
import { k3docReducer } from './k3docReducer';
import { k3scriptReducer } from './k3scriptReducer';
import { k3agentReducer } from './k3agentReducer';
import { k3taskReducer } from './k3taskReducer';
import { permissionReducer } from './permissionReducer';
import { userReducer } from './userReducer';
import { userGroupReducer } from './userGroupReducer';
import { k3flowReducer } from './k3flowReducer';

const reducers = combineReducers({
  authenReducer,
  myRecordReducer,
  listingReducer,
  shopReducer,
  shopSoldReducer,
  taskReducer,
  collectionReducer,
  botReducer,
  socketReducer,
  miscReducer,
  localDataReducer,
  autoP2PReducer,
  aiConversationReducer,
  aiMessageReducer,
  projectReducer,
  commitReducer,
  k3docReducer,
  k3scriptReducer,
  k3agentReducer,
  k3taskReducer,
  permissionReducer,
  userReducer,
  userGroupReducer,
  k3flowReducer
});

export default reducers;
